<template>
  <div>
    <vue-slider
      :value="value"
      @change="$emit('input', $event)"
      :data="sliderData"
      :tooltip="'none'"
      :process="false"
      class="main-class">
    </vue-slider>
    <div class="fake-slider"></div>
    <div class="my-container">
      <div v-if="value === '25'" class="first-number-alternative">25</div>
      <div v-if="value !== '25'" class="first-number">25</div>
      <div v-if="value === '50'" class="second-number-alternative">50</div>
      <div v-if="value !== '50'" class="second-number">50</div>
      <div v-if="value === '75'" class="third-number-alternative">75</div>
      <div v-if="value !== '75'" class="third-number">75</div>
    </div>
  </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
export default {
  components: {
    VueSlider
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      sliderValue: this.value,
      sliderData: ['25', '50', '75']
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../assets/stylesheets/vars';
  .main-class {
    position: relative;
    /deep/ .vue-slider-rail {
      background: $pcg-light-gray-background;
      border-radius: 10px;
      height: 12px;
      width: calc(100% - 30px);
      margin: 0 auto;
      cursor: pointer;
    }
    /deep/ .vue-slider-dot-handle {
      cursor: pointer;
      width: 30px;
      position: relative;
      z-index: 2;
      height: 30px;
      border-radius: 50%;
      background-color: $main-color;
    }
    /deep/ .vue-slider-dot {
      position: relative;
      width: 30px !important;
      height: 30px !important;
    }
  }
  .fake-slider {
    position: relative;
    background: $pcg-light-gray-background;
    border-radius: 10px;
    height: 14px;
    bottom: 12px;
    pointer-events: none;
    width: 100%;
  }
  .my-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: relative;
    width: 100%;
  }
  .first-number {
    position: relative;
    left: 7.5px;
    bottom: 2.1rem;
    color: $pcg-the-darkest-gray;
    font-weight: 400;
    pointer-events: none;
  }
  .first-number-alternative {
    position: relative;
    left: 7.5px;
    bottom: 2.1rem;
    color: $pcg-white;
    font-weight: 400;
    z-index: 6;
    pointer-events: none;
  }
  .second-number {
    position: relative;
    color: $pcg-the-darkest-gray;
    font-weight: 400;
    bottom: 2.1rem;
    pointer-events: none;
  }
  .second-number-alternative {
    position: relative;
    bottom: 2.1rem;
    color: $pcg-white;
    font-weight: 400;
    z-index: 6;
    pointer-events: none;
  }
  .third-number {
    position: relative;
    bottom: 2.1rem;
    right: 7.5px;
    color: $pcg-the-darkest-gray;
    font-weight: 400;
    pointer-events: none;
  }
  .third-number-alternative {
    position: relative;
    bottom: 2.1rem;
    right: 7.5px;
    text-align: center;
    color: $pcg-white;
    font-weight: 400;
    z-index: 6;
    pointer-events: none;
  }
</style>

<style lang="scss" scoped>
  @import "../assets/stylesheets/vars-contrast";
  .contrast {
    .main-class {
      /deep/ .vue-slider-rail {
        background: $pcg-light-gray;
      }
      /deep/ .vue-slider-dot-handle {
        background-color: $main-color;
      }
    }
    .fake-slider {
      background: $pcg-light-gray;
    }
    .first-number {
      color: $pcg-the-darkest-gray;
    }
    .first-number-alternative {
      color: $pcg-white;
    }
    .second-number {
      color: $pcg-the-darkest-gray;
    }
    .second-number-alternative {
      color: $pcg-white;
    }
    .third-number {
      color: $pcg-the-darkest-gray;
    }
    .third-number-alternative {
      color: $pcg-white;
    }
  }
</style>
